/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import { PlusIcon } from '../../../../../images/icons/Plus/Plus'

const NewRateVariation = (props: any) => (
    <div className="quote__form__dynamic--add variation__block variation__block--new" onClick={props.onClick}>
        <PlusIcon /><span>Request Rate</span><PlusIcon />
    </div>
)

export default  NewRateVariation



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05c/components/NewRateVariation.tsx